
import React from 'react';
import { Link } from 'react-router-dom';
import { Separator } from './ui/separator';
import { Mail, Heart, Facebook, Twitter } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-50 border-t py-12 mt-auto">
      <div className="container px-4 mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="inline-flex items-center">
              <span className="text-2xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                <span className="t-logo">t</span>ravilis
              </span>
            </Link>
            <p className="text-sm text-muted-foreground mt-3 max-w-md">
              Your passport to authentic local experiences. Connect with local hosts and discover unique adventures worldwide.
            </p>
            <div className="flex space-x-4 mt-6">
              <a href="https://facebook.com" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://twitter.com" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Twitter">
                <Twitter size={20} />
              </a>
            </div>
          </div>
          
          {/* Host Section */}
          <div className="space-y-4">
            <h4 className="font-semibold text-base">Hosting</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/auth?mode=signup&role=host" className="text-sm text-muted-foreground hover:text-primary hover:underline transition-colors">
                  Become a Host
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Contact Info - Only Email */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex items-center">
            <Mail size={18} className="text-primary mr-2" />
            <span className="text-sm">support@travilis.com</span>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-muted-foreground mb-4 md:mb-0">
              © {currentYear} Travilis. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link to="/accessibility" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                Accessibility
              </Link>
              <Link to="/sitemap" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                Sitemap
              </Link>
              <div className="flex items-center">
                <Heart size={16} className="text-primary mr-1.5" />
                <span className="text-sm text-muted-foreground">Built with love</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
